export default __webpack_public_path__ + "static/media/online plane ticket.e096f8fd.png";